import React, { useState } from 'react';
import './LGPDExclusionPage.css';
import logo from '../assets/logo.png';

export default function LGPDExclusionPage() {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    document: '',
    consent1: false,
    consent2: false
  });
  const [sent, setSent] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [response, setResponse] = useState({
    data: '',
    protocolo: ''
  });
  const API_URL = process.env.REACT_APP_API_URL || '';

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === 'checkbox' ? checked : value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = 'Informe seu nome completo.';
    if (!form.phone.trim()) newErrors.phone = 'Informe seu telefone.';
    if (!form.email.trim()) {
      newErrors.email = 'Informe seu e-mail.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = 'Informe um e-mail válido.';
    }
    if (!form.document.trim()) newErrors.document = 'Informe seu CPF.';
    if (!form.consent1) newErrors.consent1 = 'Você deve confirmar o exercício do direito de exclusão.';
    if (!form.consent2) newErrors.consent2 = 'Você deve confirmar a titularidade dos dados.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!validate()) return;
    setIsSubmitting(true);

    try {
      const res = await fetch(`${API_URL}/api/exclusao-lgpd`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...form }),
      });

      const data = await res.json();

      if (data.success) {
        setSent(true);
        setResponse(data);
      } else {
        console.log(data.erro || 'Erro ao processar.');
        newErrors.consent2 = data.erro || 'Erro ao processar.';
        setErrors(newErrors);
      }
    } catch (e) {
      console.log('Não foi possível conectar à API. Verifique se o backend está rodando.');
      newErrors.api = 'Não foi possível fazer a solicitação, favor entrar em contato com o suporte.';
      setErrors(newErrors);
    } finally {
      setIsSubmitting(false); 
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const formatCPF = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
  };

  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    if (digits.length <= 2) return digits;
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  };

  const handleDocumentChange = (e) => {
    setForm({ ...form, document: formatCPF(e.target.value) });
    if (errors.document) setErrors({ ...errors, document: '' });
  };

  const handlePhoneChange = (e) => {
    setForm({ ...form, phone: formatPhone(e.target.value) });
    if (errors.phone) setErrors({ ...errors, phone: '' });
  };

  return (
    <div className="exclusion-root">
      {/* Header */}
      <header className="exclusion-header">
        <div className="container">
          <div className="exclusion-header-inner">
            <a href="/" className="exclusion-logo"><img src={logo} alt="AnaliseCentral" style={{height: '100px'}} /></a>
            <nav className="exclusion-header-nav">
              <a href="/">Página Inicial</a>
              <a href="/lgpd/terms">Termos de Uso</a>
              <a href="/lgpd/privacy">Política de Privacidade</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero */}
      <div className="exclusion-hero">
        <div className="container">
          <span className="exclusion-hero-label">LGPD — Lei nº 13.709/2018</span>
          <h1>Solicitação de Remoção de Dados</h1>
          <p className="exclusion-hero-desc">
            Conforme a Lei Geral de Proteção de Dados (LGPD), todo titular pode solicitar a exclusão
            dos seus dados pessoais. Preencha o formulário abaixo. Após validarmos sua titularidade,
            enviaremos a confirmação da exclusão em até <strong>48 horas úteis</strong>.
          </p>
        </div>
      </div>

      <div className="exclusion-layout container">
        {/* Info Sidebar */}
        <aside className="exclusion-info">
          <div className="info-card">
            <div className="info-icon-lg">🛡️</div>
            <h3>Transparência e Segurança</h3>
            <p>
              Temos como prioridade a transparência e a segurança das informações dos nossos usuários.
              Os dados exibidos nesta plataforma são obtidos e tratados a partir de fontes públicas e
              legítimas, sempre em conformidade com a Lei Geral de Proteção de Dados
              (<strong>LGPD — Lei nº 13.709/2018</strong>).
            </p>
          </div>

          <div className="info-card">
            <div className="info-icon-lg">⏱️</div>
            <h3>Prazo de Resposta</h3>
            <p>
              Após o recebimento da sua solicitação, nossa equipe analisará os dados informados para
              confirmar a titularidade. A confirmação da exclusão será enviada em até
              <strong>48 horas úteis</strong>.
            </p>
          </div>

          <div className="info-card">
            <div className="info-icon-lg">📧</div>
            <h3>Canal de Atendimento</h3>
            <p>
              Em caso de dúvidas sobre o processo de exclusão, entre em contato pelo e-mail:
            </p>
            <a href="mailto:suporte@analisecadastral.com.br" className="info-email">
              suporte@analisecadastral.com.br
            </a>
          </div>
        </aside>

        {/* Form */}
        <main className="exclusion-form-wrapper">
          {!sent ? (
            <>
              <div className="form-header">
                <h2>Formulário de Solicitação</h2>
                <p>Preencha todos os campos obrigatórios para prosseguir com a exclusão.</p>
                {errors.api && <span className="error-msg">{errors.api}</span>}
              </div>

              <form onSubmit={onSubmit} className="exclusion-form" noValidate>
                <div className="form-grid">
                  <div className={`form-group ${errors.name ? 'error' : ''}`}>
                    <label htmlFor="name">
                      Nome Completo <span className="required">*</span>
                    </label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      value={form.name}
                      onChange={onChange}
                      placeholder="Digite seu nome completo"
                      autoComplete="name"
                    />
                    {errors.name && <span className="error-msg">{errors.name}</span>}
                  </div>

                  <div className={`form-group ${errors.phone ? 'error' : ''}`}>
                    <label htmlFor="phone">
                      Telefone <span className="required">*</span>
                    </label>
                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      value={form.phone}
                      onChange={handlePhoneChange}
                      placeholder="(00) 00000-0000"
                      autoComplete="tel"
                    />
                    {errors.phone && <span className="error-msg">{errors.phone}</span>}
                  </div>

                  <div className={`form-group ${errors.email ? 'error' : ''}`}>
                    <label htmlFor="email">
                      E-mail <span className="required">*</span>
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={form.email}
                      onChange={onChange}
                      placeholder="seu@email.com"
                      autoComplete="email"
                    />
                    {errors.email && <span className="error-msg">{errors.email}</span>}
                  </div>

                  <div className={`form-group ${errors.document ? 'error' : ''}`}>
                    <label htmlFor="document">
                      CPF <span className="required">*</span>
                    </label>
                    <input
                      id="document"
                      name="document"
                      type="text"
                      value={form.document}
                      onChange={handleDocumentChange}
                      placeholder="000.000.000-00"
                      autoComplete="off"
                    />
                    {errors.document && <span className="error-msg">{errors.document}</span>}
                  </div>
                </div>

                <div className="declarations">
                  <h3>Declaração de Titularidade</h3>

                  <div className={`checkbox-group ${errors.consent1 ? 'error' : ''}`}>
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="consent1"
                        checked={form.consent1}
                        onChange={onChange}
                      />
                      <span className="checkmark"></span>
                      <span className="checkbox-text">
                        Desejo exercer meu direito de exclusão conforme a LGPD.
                      </span>
                    </label>
                    {errors.consent1 && <span className="error-msg">{errors.consent1}</span>}
                  </div>

                  <div className={`checkbox-group ${errors.consent2 ? 'error' : ''}`}>
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="consent2"
                        checked={form.consent2}
                        onChange={onChange}
                      />
                      <span className="checkmark"></span>
                      <span className="checkbox-text">
                        Declaro que os dados informados são verdadeiros e de minha titularidade.
                      </span>
                    </label>
                    {errors.consent2 && <span className="error-msg">{errors.consent2}</span>}
                  </div>
                </div>

                <div className="form-actions">
                  <button
                    type="submit"
                    className="btn-primary"
                    disabled={isSubmitting} // ← DESABILITA DURANTE O ENVIO
                  >
                    {isSubmitting ? 'Enviando...' : 'Enviar Solicitação'}
                  </button>
                  <p className="form-note">
                    Ao enviar, você confirma que leu e concorda com os procedimentos descritos
                    na <a href="#">Política de Privacidade</a>.
                  </p>
                </div>
              </form>
            </>
          ) : (
            <div className="success-card">
              <div className="success-icon">✓</div>
              <h2>Solicitação Enviada com Sucesso</h2>
              <p>
                Recebemos sua solicitação de remoção de dados. Nossa equipe irá validar sua titularidade
                e enviar a confirmação da exclusão para o e-mail <strong>{form.email}</strong> em até
                <strong> 48 horas úteis</strong>.
              </p>
              <div className="success-details">
                <div className="success-row">
                  <span>Protocolo</span>
                  <span>#{response.protocolo}</span>
                </div>
                <div className="success-row">
                  <span>Data da solicitação</span>
                  <span>{response.data}</span>
                </div>
              </div>
              <a href="/" className="btn-secondary">Voltar para a página inicial</a>
            </div>
          )}
        </main>
      </div>

      {/* Footer */}
      <footer className="exclusion-footer">
        <div className="container">
          <div className="exclusion-footer-inner">
            <p>© Análise Central. Todos os direitos reservados.</p>
            <div className="exclusion-footer-links">
              <a href="/">Página Inicial</a>
              <a href="/lgpd/terms">Termos de Uso</a>
              <a href="/lgpd/privacy">Política de Privacidade</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}